import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BadgeCheck, X, MapPin } from 'lucide-react';
const NAMES = ['Dr. Martín G.', 'Dra. Lucía R.', 'Dr. Federico S.', 'Dra. Carolina M.', 'Dr. Sebastián P.', 'Dra. Valentina A.', 'Dr. Joaquín L.', 'Dra. Florencia D.', 'Dr. Nicolás T.', 'Dra. Agustina F.', 'Dr. Tomás B.', 'Dra. Sofía C.', 'Dr. Matías V.', 'Dra. Julieta N.', 'Dr. Gonzalo H.', 'Dra. Camila E.', 'Dr. Ignacio Q.', 'Dra. Mariana O.', 'Dr. Pablo Z.', 'Dra. Daniela U.'];
const CITIES = ['CABA', 'La Plata, Bs. As.', 'Córdoba', 'Rosario, Santa Fe', 'Mendoza', 'San Miguel de Tucumán', 'Mar del Plata, Bs. As.', 'Salta', 'Santa Fe', 'Neuquén', 'Bahía Blanca, Bs. As.', 'Resistencia, Chaco', 'Posadas, Misiones', 'San Juan', 'Paraná, Entre Ríos', 'Corrientes', 'Río Cuarto, Córdoba'];
const PLANS = ['el Kit Esencial', 'el Megapack'];
interface Notice {
  id: number;
  name: string;
  city: string;
  plan: string;
}
function rand<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
export function PurchaseNotification() {
  const [notice, setNotice] = useState<Notice | null>(null);
  const showNotice = useCallback(() => {
    setNotice({
      id: Date.now(),
      name: rand(NAMES),
      city: rand(CITIES),
      plan: rand(PLANS)
    });
    // se oculta solo después de ~6s
    window.setTimeout(() => {
      setNotice(curr => curr && curr.id ? null : curr);
    }, 6000);
  }, []);
  useEffect(() => {
    let timeoutId: number;
    const schedule = (delay: number) => {
      timeoutId = window.setTimeout(() => {
        showNotice();
        // próximo aviso entre 40 y 60 segundos
        schedule(40000 + Math.random() * 20000);
      }, delay);
    };
    // primer aviso a los ~8s de cargar la página
    schedule(8000);
    return () => window.clearTimeout(timeoutId);
  }, [showNotice]);
  return <div className="fixed bottom-3 left-3 sm:bottom-5 sm:left-5 z-50 pointer-events-none" data-id="element-268">
      <AnimatePresence data-id="element-269">
        {notice && <motion.div key={notice.id} initial={{
        opacity: 0,
        x: -40,
        y: 10
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -40
      }} transition={{
        type: 'spring',
        stiffness: 260,
        damping: 24
      }} className="pointer-events-auto w-[17rem] sm:w-80 bg-white rounded-xl shadow-2xl border border-slate-200 overflow-hidden" role="status" aria-live="polite" data-id="element-270">
            <div className="flex items-start gap-3 p-3 sm:p-3.5" data-id="element-271">
              <div className="shrink-0 w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-teal-50 border border-teal-100 flex items-center justify-center" data-id="element-272">
                <BadgeCheck className="w-5 h-5 sm:w-6 sm:h-6 text-teal-600" data-id="element-273" />
              </div>
              <div className="min-w-0 flex-1" data-id="element-274">
                <div className="flex items-center gap-1.5 mb-0.5" data-id="element-275">
                  <span className="text-[10px] sm:text-xs font-bold text-teal-600 uppercase tracking-wide" data-id="element-276">
                    Compra verificada
                  </span>
                  <span className="inline-block w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse" data-id="element-277" />
                </div>
                <p className="text-xs sm:text-sm text-slate-800 leading-snug" data-id="element-278">
                  <span className="font-bold" data-id="element-279">{notice.name}</span> compró ahora{' '}
                  <span className="font-bold" data-id="element-280">{notice.plan}</span>
                </p>
                <p className="text-[10px] sm:text-xs text-slate-400 mt-0.5 flex items-center gap-1" data-id="element-281">
                  <MapPin className="w-3 h-3" data-id="element-282" /> {notice.city} · hace unos
                  segundos
                </p>
              </div>
              <button onClick={() => setNotice(null)} aria-label="Cerrar notificación" className="shrink-0 text-slate-300 hover:text-slate-500 transition-colors -mt-0.5 -mr-0.5" data-id="element-283">
                <X className="w-4 h-4" data-id="element-284" />
              </button>
            </div>
            {/* barra de tiempo */}
            <motion.div initial={{
          width: '100%'
        }} animate={{
          width: '0%'
        }} transition={{
          duration: 6,
          ease: 'linear'
        }} className="h-1 bg-teal-500" data-id="element-285" />
          </motion.div>}
      </AnimatePresence>
    </div>;
}